export default {
    "Copy": "Copier",
    "SEND": "ENVOYER",
    "Email": "Email",
    "Adjust your source volume": "Ajuster le volume de votre source",

    // Toggle confirmation modal
    "Cancel": "Annuler",
    "Confirm": "Confirmer",
    "The player will restart.": "Le player va redémarrer.",
    
    // Multi Upload
    "slides uploaded": "diapos envoyées",
    "files uploaded": "fichiers envoyés",
    "Remove all": "Tout supprimer",

    "No items added": "Aucun élément ajouté",

    // Open component
    "Open": "Ouvrir",
    "title...": "titre...",

    // Pour les composants dynamiques comme Toggle, les traductions seront ajoutées au besoin
    // en fonction des labels et tooltips spécifiques utilisés dans l'application
}